import { render, staticRenderFns } from "./SetupProfile.vue?vue&type=template&id=08d69bec&scoped=true"
import script from "./SetupProfile.vue?vue&type=script&lang=js"
export * from "./SetupProfile.vue?vue&type=script&lang=js"
import style0 from "./SetupProfile.vue?vue&type=style&index=0&id=08d69bec&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d69bec",
  null
  
)

export default component.exports